import { type FC } from 'react';
import { type RouteProps } from 'react-router-dom';
import { LogoVersion } from '~/_shared/components/logo/logo.helpers';
import { OverlayLoaderComponent } from '~/_shared/components/overlay/overlayLoader.component';
import { BrandedAuthPageLayoutComponent } from '~/authorization/pageWrapper/brandedAuthPageLayoutComponent';
import { LoginFormContainer } from './loginForm/loginForm.container';

const LOGIN_PAGE_CANONICAL_URL = 'https://www.maptive.com/login.html';

type LoginPageProps = RouteProps & {
  isLoading?: boolean;

  onLoginFormSubmit: () => void;
};

export const LoginPageComponent: FC<LoginPageProps> = (props) => {
  return (
    <>
      <link rel="canonical" href={LOGIN_PAGE_CANONICAL_URL} />
      <BrandedAuthPageLayoutComponent
        logoVersion={LogoVersion.variantB}
      >
        {props.isLoading && <OverlayLoaderComponent />}
        <LoginFormContainer onLoginFormSubmit={props.onLoginFormSubmit} />
      </BrandedAuthPageLayoutComponent>
    </>
  );
};
